/*
 * home-sections.js
 * ---------------------------------------------------------------------------
 * JS compartido para las secciones del Home de ZYN.
 * Cada módulo se auto-inicializa escaneando el DOM por un data-attribute y se
 * marca como inicializado para no correr dos veces. Es idempotente y soporta
 * los eventos del theme editor (shopify:section:load / :select).
 *
 * Módulos:
 *   - Home Hero            ->  [data-home-hero]
 *   - Critically Acclaimed ->  [data-crit]
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';
  if (window.__zynHomeSections) return; // evita registrar los listeners dos veces
  window.__zynHomeSections = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ===================== Home Hero (carrusel) ===================== */
  function initHero(root) {
    if (!root || root.hasAttribute('data-hh-init')) return;
    root.setAttribute('data-hh-init', '');

    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    root.style.setProperty('--hh-interval', (interval / 1000) + 's');

    var slides = Array.prototype.slice.call(root.querySelectorAll('.home-hero__slide'));
    var tabs   = Array.prototype.slice.call(root.querySelectorAll('.home-hero__tab'));
    if (slides.length < 2) return;

    var current = 0, timer = null;

    // Solo el slide visible reproduce su video de fondo; los demas se pausan
    // para no gastar CPU/ancho de banda decodificando algo que no se ve.
    function syncVideos(i) {
      slides.forEach(function (s, j) {
        var v = s.querySelector('video');
        if (!v) return;
        if (j === i) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }

    function show(i) {
      current = i;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      syncVideos(i);
      tabs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        var prog = t.querySelector('.home-hero__tab-prog');
        if (prog) { prog.style.animation = 'none'; void prog.offsetWidth; prog.style.animation = ''; }
      });
    }
    function next()  { show((current + 1) % slides.length); }
    function start() { if (reduce) return; stop(); timer = setInterval(next, interval); }
    function stop()  { if (timer) { clearInterval(timer); timer = null; } }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); start(); });
    });

    // Theme editor: al seleccionar un slide, mostrarlo y pausar.
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('.home-hero__slide') : null;
      if (slide && root.contains(slide)) {
        stop();
        show(parseInt(slide.getAttribute('data-slide-index'), 10) || 0);
      }
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (root.contains(e.target)) start();
    });

    show(0);
    start();
  }

  /* ============== Critically Acclaimed (tabs por crítico) ============== */
  function initCritics(root) {
    if (!root || root.hasAttribute('data-crit-init')) return;
    root.setAttribute('data-crit-init', '');

    var tabs  = Array.prototype.slice.call(root.querySelectorAll('.crit__tab'));
    var panes = Array.prototype.slice.call(root.querySelectorAll('.crit__pane'));
    var btn   = root.querySelector('[data-crit-btn]');
    var btnLbl = root.querySelector('[data-crit-btn-label]');
    if (!tabs.length) return;

    function show(i) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panes.forEach(function (p, j) { p.classList.toggle('is-active', j === i); });
      // El botón sigue al tab activo: link y, si el block lo define, texto.
      var url = tabs[i].getAttribute('data-url');
      if (btn && url) btn.setAttribute('href', url);
      var label = tabs[i].getAttribute('data-btn-label');
      if (btnLbl && label) btnLbl.textContent = label;
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });

    // Theme editor: al seleccionar un block de crítico, abrir su tab.
    document.addEventListener('shopify:block:select', function (e) {
      var pane = e.target && e.target.closest ? e.target.closest('.crit__pane') : null;
      if (pane && root.contains(pane)) {
        show(parseInt(pane.getAttribute('data-crit-pane'), 10) || 0);
      }
    });

    show(0);
  }

  /* ===================== Grilla desde una URL filtrada de Boost =============
     Los parametros pf_* de la URL de coleccion los resuelve Boost contra su
     propio indice: Liquid no los ve y Shopify no los entiende, asi que la unica
     forma de listar ese resultado fuera de la pagina de coleccion es pedirselo
     al API de Boost desde el navegador.

     El detalle que hace que funcione: en el API el nombre del parametro lleva
     "[]" al final. La URL del storefront usa pf_m_::netsuite::country=Spain,
     pero el endpoint solo filtra con pf_m_::netsuite::country[]=Spain; sin los
     corchetes ignora el filtro en silencio y devuelve la coleccion entera.
     ======================================================================== */

  var BOOST_API = 'https://services.mybcapps.com/bc-sf-filter/filter';

  // Los filtros pf_st_ (stock) usan en la URL etiquetas legibles pero en el API
  // booleanos. Mandar el valor de la URL tal cual devuelve 400 con
  // "The 'pf_st_availability' field only accepts boolean values".
  var BOOST_VALUE_MAP = {
    'pf_st_availability': { 'out-of-stock': 'false', 'in-stock': 'true' }
  };

  function money(n) {
    var v = parseFloat(n);
    if (isNaN(v)) return '';
    return '$' + v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function boostUrl(el) {
    var params = new URLSearchParams();
    params.set('shop', el.getAttribute('data-boost-shop'));
    params.set('collection_scope', el.getAttribute('data-boost-collection'));
    params.set('urlScheme', '2');
    params.set('build_filter_tree', 'true');
    params.set('page', '1');
    params.set('limit', el.getAttribute('data-boost-limit') || '8');
    var srcSort = new URLSearchParams(el.getAttribute('data-boost-query') || '').get('sort');
    params.set('sort', srcSort || 'manual');
    params.set('zero_options', 'true');
    params.set('product_available', 'false');
    params.set('variant_available', 'false');
    if (el.getAttribute('data-boost-available-first') === 'true') {
      params.set('sort_first', 'available');
    }

    var src = new URLSearchParams(el.getAttribute('data-boost-query') || '');
    src.forEach(function (value, key) {
      if (key.indexOf('pf_') !== 0) return;
      var bare = key.slice(-2) === '[]' ? key.slice(0, -2) : key;
      var map = BOOST_VALUE_MAP[bare];

      params.append(bare + '[]', (map && map[value] !== undefined) ? map[value] : value);
    });

    return BOOST_API + '?' + params.toString();
  }

  var CRITICS = [
    ['wine_spectator', 'WS'], ['robert_parker', 'RP'], ['james_suckling', 'JS'],
    ['wine_enthusiast', 'WE'], ['decanter', 'D'], ['vinous', 'V'],
    ['jeb_dunnuck', 'JD'], ['tim_atkin', 'TA'], ['allen_meadows_burghound', 'BH'],
    ['wine_and_spirits', 'W&S'], ['whisky_advocate', 'WA']
  ];

  function metaMap(p) {
    var out = {};
    (p.metafields || []).forEach(function (m) {
      if (m && m.namespace && m.key) out[m.namespace + '.' + m.key] = m.value;
    });
    return out;
  }

  function bestScore(mf) {
    var best = 0, initial = '';
    CRITICS.forEach(function (c) {
      var v = parseFloat(mf['netsuite.' + c[0]]);
      if (!isNaN(v) && v > best) { best = v; initial = c[1]; }
    });
    return best > 0 ? { score: Math.floor(best), initial: initial } : null;
  }

  function boostCard(p, cta, colClass, mobileOne) {
    var mf = metaMap(p);
    var url = '/products/' + p.handle;
    var soldOut = !p.available;

    var img = '';
    if (p.images_info && p.images_info.length && p.images_info[0].src) img = p.images_info[0].src;
    else if (p.images && p.images['1']) img = p.images['1'];
    // El CDN de Shopify acepta ?width= y devuelve WebP; sin esto se baja el
    // original de 1250px para mostrarlo a ~250.
    var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=500' : '';

    var price = parseFloat(p.price_min);
    var wasNum = parseFloat(p.compare_at_price_min);
    var onSale = !isNaN(wasNum) && wasNum > price;

    // --- badges sobre la foto: puntaje + formato de caja ---
    var rate = bestScore(mf);
    var pres = mf['netsuite.presentation'] || '';
    var boxText = pres;
    var boxUnits = 0;
    if (boxText.toLowerCase() === 'single') boxText = '';
    if (!pres) {
      (p.tags || []).forEach(function (t) {
        if (t.indexOf('CASE-') !== 0) return;
        boxUnits = parseInt(t.split('CASE-')[1], 10) || 0;
        boxText = boxUnits ? boxUnits + ' Pack' : '';
      });
    } else if (boxText) {
      boxUnits = parseInt(boxText.split(' ')[0], 10) || 0;
    }
    var tags = '';
    if (rate || boxText) {
      tags = '<div class="tags-container">' +
        (rate ? '<div class="rate-tag"><span class="critic">' + esc(rate.initial) + '</span>' +
                '<span class="score">' + rate.score + '</span></div>' : '') +
        (boxText ? '<span class="box-case-number' + (onSale ? ' discounted' : '') + '">' + esc(boxText) + '</span>' : '') +
      '</div>';
    }

    var loc = [mf['netsuite.subregion'], mf['netsuite.region'], mf['netsuite.country']]
      .map(function (x) { return (x || '').trim(); })
      .filter(function (x) { return x; })
      .join(', ');

    // --- accion ---
    var variants = p.variants || [];
    var single = variants.length === 1 ? variants[0] : null;
    var action = '';
    if (soldOut) {
      var fv = variants[0] || {};
      action =
        '<div class="cart-with-savings">' +
          '<button type="button" class="klaviyo-bis-trigger pc-notify-btn"' +
            ' id="klaviyo-bis-trigger" dataVariant="' + (fv.id || '') + '">' +
            '<span class="klaviyo-text">Notify me</span>' +
          '</button>' +
          '<input type="hidden" name="id" class="first-variant" id="first-variant" value="' + (fv.id || '') + '">' +
          '<input type="hidden" name="idProduct" class="idProduct" id="idProduct" value="' + p.id + '">' +
          '<input type="hidden" name="titleProduct" class="titleProduct" id="titleProduct" value="' + esc(p.title) + '">' +
        '</div>';
    } else if (single && single.available) {
      action =
        '<div class="cart-with-savings">' +
          '<div class="inline-quickshop' + (onSale ? ' is-on-sale' : '') + '">' +
            '<form action="/cart/add" method="post" enctype="multipart/form-data">' +
              '<input type="hidden" name="id" value="' + single.id + '">' +
              '<input type="hidden" class="quantity" name="quantity" value="1">' +
              '<div class="purchase-details is-flex">' +
                '<div class="purchase-details__buttons purchase-details__spb--false">' +
                  '<button type="button" class="add_to_cart ajax-submit global-button ' +
                    (onSale ? 'global-button--sale' : 'global-button--primary') + '">' +
                    '<span class="text">Add to Cart</span>' +
                  '</button>' +
                '</div>' +
              '</div>' +
            '</form>' +
          '</div>' +
        '</div>';
    } else {
      action =
        '<div class="cart-with-savings">' +
          '<a href="' + url + '" class="variant-cta global-button ' +
            (onSale ? 'global-button--sale' : 'global-button--primary') + '">' + esc(cta || 'Select options') + '</a>' +
        '</div>';
    }

    var meta = '';
    if (onSale && !soldOut) {
      meta += '<span class="was_price">Regular <s><span class="money">' + money(wasNum) + '</span></s></span>';
    }

    if (boxText && boxUnits > 0 && !soldOut && variants.length === 1) {
      meta += '<div class="includes-and-price-text">Includes ' + boxUnits +
              ' units ' + money(price / boxUnits) + ' each</div>';
    }
    if (onSale && !soldOut) {
      var savedPct = Math.round(((wasNum - price) / wasNum) * 100);
      meta += '<span class="sale savings">Save ' + money(wasNum - price) + ' (' + savedPct + '%)</span>';
    }

    var noCompare = (soldOut || variants.length > 1) ? ' no-compare-at-price' : '';
    var mobileCls = mobileOne ? ' medium-down--one-whole small-down--one-whole' : ' medium-down--one-whole';

    return '' +
    '<div class="' + colClass + ' column thumbnail' + mobileCls + '">' +
      '<div class="product-' + p.id + '">' +
        '<div class="product-wrap">' +
          '<div class="relative product_image">' +
            '<a href="' + url + '">' +
              '<div class="image__container">' +
                (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
              '</div>' +
            '</a>' +
            tags +
            (soldOut ? '<div class="pc-soldout-overlay"><span>SOLD OUT</span></div>' : '') +
          '</div>' +
          '<div class="product-details' + noCompare + '">' +
            '<div class="product-title-location">' +
              '<span class="title"><a href="' + url + '">' + esc(p.title) + '</a></span>' +
              (loc ? '<p class="product-location">' + esc(loc) + '</p>' : '') +
            '</div>' +
            '<div class="price-and-cart">' +
              '<div class="price-row">' +
                '<span class="price' + (onSale && !soldOut ? ' price--sale' : '') + '">' +
                  '<span class="current_price">' +
                    '<span class="money' + (soldOut ? ' pc-soldout-price' : '') + '">' + money(price) + '</span>' +
                  '</span>' +
                '</span>' +
                (soldOut ? '<div class="last-unit-sold-at">LAST UNIT SOLD FOR</div>' : '') +
                (onSale && !soldOut ? '<span class="on-sale-label">ON SALE</span>' : '') +
              '</div>' +
              action +
            '</div>' +
            '<div class="card-meta">' + meta + '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function initBoostGrid(el) {
    if (el.dataset.boostReady) return;
    el.dataset.boostReady = '1';
    el.setAttribute('data-loading', '');

    var cta = el.getAttribute('data-boost-cta');

    fetch(boostUrl(el), { credentials: 'omit' })
      .then(function (r) {
        if (r.ok) return r.json();
        // El API explica el motivo en el body ("… only accepts boolean
        // values"); sin esto el error queda en un HTTP 400 sin pistas.
        return r.text().then(function (body) {
          throw new Error('HTTP ' + r.status + ' — ' + body.slice(0, 200));
        });
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        el.removeAttribute('data-loading');
        if (!products.length) {
          el.innerHTML = '<p class="crit__bmsg">No products match this filter right now.</p>';
          return;
        }

        var colClass = el.getAttribute('data-boost-col-class') || 'one-fourth';
        var mobileOne = el.getAttribute('data-boost-mobile-one') === 'true';
        el.innerHTML = products.map(function (p) {
          return boostCard(p, cta, colClass, mobileOne);
        }).join('');
      })
      .catch(function (err) {
        el.removeAttribute('data-loading');
        el.innerHTML = '<p class="crit__bmsg">Couldn\u2019t load these products.</p>';
        if (window.console) console.error('[crit-boost]', err);
      });
  }

  /* ===================== Bootstrap ===================== */
  function scan(scope) {
    var ctx = scope || document;
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-home-hero]'), initHero);
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-crit]'), initCritics);
    Array.prototype.forEach.call(ctx.querySelectorAll('[data-crit-boost]'), initBoostGrid);
  }

  function boot() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-escanea cuando el theme editor re-renderiza una sección.
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target || document);
  });
})();
